export const environment = {
	production: false,
	apiUrl: 'https://api-uat.turbotl.com/api',
	domain: 'dev-vu1ncrwjkvdx0ox2.us.auth0.com',
	clientId: 'ymbG1G3Ry8UsW2k56s4qsLcqx3VctO4L',
	audience: 'https://api-uat.turbotl.com'

};
